"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class Collection extends Parse.Object {
    constructor(attributes) {
        super('Collection', attributes);
    }
    get name() { return this.get('name'); }
    set name(value) { this.set('name', value); }
    get description() { return this.get('description'); }
    set description(value) { this.set('description', value); }
    get image() { return this.get('image'); }
    set image(value) { this.set('image', value); }
    get products() { return this.relation('products'); }
    // set products(value: Parse.Relation) { this.set('products', value) }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    get salesPerson() { return this.get('salesPerson'); }
    set salesPerson(value) { this.set('salesPerson', value); }
    get canonicalName() { return this.get('canonicalName'); }
    set canonicalName(value) { this.set('canonicalName', value); }
    // collection is blocked for sales.
    get blocked() { return this.get('blocked'); }
    set blocked(value) { this.set('blocked', value); }
}
exports.Collection = Collection;
Parse.Object.registerSubclass('Collection', Collection);
//# sourceMappingURL=Collection.js.map